/* eslint-disable camelcase */
import React from 'react';

import ItemOptionSelectQuestionPresentation from './ItemOptionSelectQuestionPresentation';

export default class ItemOptionSelectQuestion extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showAllContent: false,
            checkedQuestion: false,
        };
    }

    componentDidMount() {
        const { checked } = this.props;

        this.setState({ checkedQuestion: checked });
    }

    componentDidUpdate(prevProps, prevState) {
        const { checkedQuestion } = this.state;
        const { onChangeSelect, question } = this.props;

        if (prevState.checkedQuestion !== checkedQuestion) {
            if (onChangeSelect) {
                onChangeSelect({
                    questionId: question.id,
                    checked: checkedQuestion,
                });
            }
        }
    }

    handleShowAllContent(currentShowAllContent) {
        this.setState({ showAllContent: !currentShowAllContent });
    }

    handleChecked({ check }) {
        this.setState({ checkedQuestion: check });
    }

    render() {
        const {
            question,
            // eslint-disable-next-line no-unused-vars
            checkDisableQuestionFn = question => {
                return false;
            },
        } = this.props;
        const { showAllContent, checkedQuestion } = this.state;

        return (
            <ItemOptionSelectQuestionPresentation
                question={question}
                handleShowAllContent={this.handleShowAllContent.bind(this)}
                showAllContent={showAllContent}
                checkedQuestion={checkedQuestion}
                handleChecked={this.handleChecked.bind(this)}
                questionDisabled={checkDisableQuestionFn(question)}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/selection-questions/ItemOptionSelectQuestion/index.js